<div class="popup">
    <div class="close-doc">
        <em class="material-icons  f-s-25" (click)="ClosePanel()">close</em>
    </div>
    <div id="imageHolder" *ngIf="Image && !docNotFound">
    </div>

    <div class="m-auto centre-spinner" *ngIf="IsLoading">
        <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
        </mat-progress-spinner>
    </div>

    <div class="pdf-container m-l-32 p-t-27" *ngIf="Pdf && !docNotFound">
        <pdf-viewer [src]="pdfSrc" [original-size]="false" style="display: block; min-height: 250px !important">
        </pdf-viewer>
    </div>

    <div *ngIf="docNotFound">
        <h5 class="mr-24">Lo sentimos pero el archivo no fue encontrado</h5>
    </div>
</div>